import {styled} from "@mui/material";

export const AddressesContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: 'start',
    gap: '1rem'
}));

export const AddressesContentContainer = styled("div")(() => ({
    backgroundColor: '#FFF',
    padding: '1rem',
    width: '100%'
}));
